import Styled from 'styled-components'

export const StyledTextEditor = Styled.div`
	& .field-disabled{
		cursor: not-allowed;
		&:before{
			content: none;
		}
		& .toolbar{
			pointer-events: none;
		}
		& .public-DraftEditor-content{
			pointer-events: none;
		}
	}
`
